// Impresión del estado de cuenta de un cliente (módulo Cobranzas), en 2 formatos:
// A4 (reporte completo, detalle con todas las columnas) y 80mm (ticket térmico,
// detalle reducido a Fecha Venta/Documento/Monto/Restante). Mismo patrón
// window.open + document.write + auto-print que imprimirVenta.js/imprimirRecibo.js.
// El usuario puede "exportar" a PDF usando la opción de impresión del navegador,
// igual que el resto de reportes del sistema (ver imprimirCaja en AperturaCajas.jsx).

function fmt2(n) {
  return parseFloat(n || 0).toFixed(2);
}

// `due_date`/`sale_date` son columnas DATE puras (sin hora) — MySQL/mysql2 las
// entrega como medianoche UTC de ese día. Forzar timeZone:'America/Lima' en un
// valor así lo CORRE un día hacia atrás (medianoche UTC = 7pm del día anterior
// en Perú). Por eso acá se extrae el día calendario directo del string ISO,
// sin construir un Date ni aplicar ninguna conversión de zona horaria.
function fmtDate(v) {
  if (!v) return '—';
  const s = String(v).slice(0, 10); // 'YYYY-MM-DD'
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : s;
}

function statusLabel(status, vencido) {
  if (status === 'paid') return 'COBRADO';
  if (vencido) return 'VENCIDO';
  if (status === 'partial') return 'PARCIAL';
  return 'PENDIENTE';
}

function docTexto(d) {
  return `${d.document_type || ''}${d.serie && d.sequence ? ` ${d.serie}-${d.sequence}` : ''}`.trim() || '—';
}

// Solo para el ticket 80mm: sin el prefijo de document_type (ej. "NP"), solo serie-secuencia.
function docTexto80(d) {
  return d.serie && d.sequence ? `${d.serie}-${d.sequence}` : '—';
}

// ── A4: reporte completo (diseño sin cambios) ──────────────────────────────
function buildHtmlA4({ empresa, client, debts, totals }) {
  const fecha = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });

  const rowsHtml = (debts || []).map(d => `
    <tr>
      <td>${fmtDate(d.sale_date)}</td>
      <td>${docTexto(d)}</td>
      <td>Cuota ${d.cuota_num}</td>
      <td class="r">S/ ${fmt2(d.amount)}</td>
      <td class="r">S/ ${fmt2(d.paid_amount)}</td>
      <td class="r" style="font-weight:700; color:${parseFloat(d.restante) > 0 ? '#dc2626' : '#16a34a'}">S/ ${fmt2(d.restante)}</td>
      <td>${statusLabel(d.status, d.vencido)}</td>
    </tr>`).join('');

  return `<!DOCTYPE html><html><head><meta charset="utf-8">
    <title>Estado de Cuenta — ${client.client_name}</title>
    <style>
      body { font-family: Arial, sans-serif; font-size: 12px; margin: 20px; color: #111; }
      h1 { font-size: 16px; color: #0d1b2e; margin-bottom: 4px; }
      h2 { font-size: 13px; color: #0369a1; margin: 16px 0 6px; border-bottom: 1px solid #e2e8f0; padding-bottom: 3px; }
      table { width: 100%; border-collapse: collapse; margin-bottom: 8px; }
      th { background: #c8ddf0; padding: 5px 8px; text-align: left; font-size: 11px; }
      td { padding: 4px 8px; border-bottom: 1px solid #f1f5f9; font-size: 11px; }
      .r { text-align: right; }
      .tot td { font-weight: bold; background: #f0f9ff; border-top: 2px solid #0d1b2e; }
      .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4px; margin-bottom: 12px; }
      .info-row { display: flex; gap: 8px; }
      .label { color: #64748b; min-width: 110px; }
      @media print { button { display: none; } }
    </style>
  </head><body>
    <h1>ESTADO DE CUENTA — ${empresa?.name || ''}</h1>
    <div style="font-size:11px; color:#64748b; margin-bottom:12px;">${empresa?.address || ''} · Generado: ${fecha}</div>

    <h2>Datos del Cliente</h2>
    <div class="info-grid">
      <div class="info-row"><span class="label">Cliente:</span> <b>${client.client_name}</b></div>
      <div class="info-row"><span class="label">Documento:</span> ${client.document_type || ''} ${client.document_number || ''}</div>
      <div class="info-row"><span class="label">Dirección:</span> ${client.address || '—'}</div>
      <div class="info-row"><span class="label">Teléfono:</span> ${client.phone || '—'}</div>
    </div>

    <h2>Detalle de Deudas</h2>
    <table>
      <tr>
        <th>Fecha de Venta</th><th>Documento</th><th>Cuota</th>
        <th class="r">Venta</th><th class="r">Abonado</th><th class="r">Deuda</th>
        <th>Estado</th>
      </tr>
      ${rowsHtml || '<tr><td colspan="7" style="color:#999; text-align:center">Sin deudas registradas</td></tr>'}
      <tr class="tot">
        <td colspan="3">SUBTOTAL</td>
        <td class="r">S/ ${fmt2(totals?.total_deuda)}</td>
        <td class="r">S/ ${fmt2(totals?.total_pagado)}</td>
        <td class="r">S/ ${fmt2(totals?.total_restante)}</td>
        <td></td>
      </tr>
    </table>

    <script>window.onload = () => { window.print(); };</script>
  </body></html>`;
}

// ── 80mm: ticket térmico — misma cabecera, detalle reducido a
// Fecha Venta / Documento / Venta / Deuda (sin Cuota, Abonado, Estado).
function buildHtml80mm({ empresa, client, debts, totals }) {
  const fecha = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });

  const rowsHtml = (debts || []).map(d => `
    <tr>
      <td>${fmtDate(d.sale_date)}</td>
      <td>${docTexto80(d)}</td>
      <td class="r">${fmt2(d.amount)}</td>
      <td class="r" style="font-weight:800">${fmt2(d.restante)}</td>
    </tr>`).join('');

  return `<!DOCTYPE html><html><head><meta charset="utf-8">
    <title>Estado de Cuenta — ${client.client_name}</title>
    <style>
      @page { size: 80mm auto; margin: 4mm; }
      /* font-weight:700 en el body — en impresoras térmicas de 80mm el texto
         normal (400) sale casi ilegible; negrita se imprime sólida. */
      body { font-family: 'Courier New', Courier, monospace; font-size: 11px; width: 72mm; margin: 0 auto; font-weight: 700; color: #000; }
      hr { border: none; border-top: 1px dashed #666; margin: 6px 0; }
      .ec-empresa-nombre { text-align: center; font-weight: 700; text-transform: uppercase; }
      .ec-empresa-linea { text-align: center; font-size: 0.85em; }
      .ec-doc { text-align: center; font-weight: 700; margin: 6px 0; text-transform: uppercase; }
      .ec-info-row { display: flex; gap: 4px; margin-bottom: 2px; }
      .ec-lbl { font-weight: 700; min-width: 62px; flex-shrink: 0; }
      .ec-detalle-title { font-weight: 700; font-size: 0.85em; margin: 10px 0 4px; text-transform: uppercase; }
      table { width: 100%; border-collapse: collapse; font-size: 0.88em; }
      th, td { padding: 3px 2px; border-bottom: 1px dashed #999; text-align: left; }
      .r { text-align: right; }
      .ec-total-line { display: flex; justify-content: space-between; align-items: baseline; font-size: 1.3em; font-weight: 800; margin-top: 4px; }
      @media print { button { display: none; } }
    </style>
  </head><body>
    <div class="ec-empresa-nombre">${empresa?.name || ''}</div>
    ${empresa?.address ? `<div class="ec-empresa-linea">${empresa.address}</div>` : ''}
    <hr />
    <div class="ec-doc">ESTADO DE CUENTA</div>
    <div style="text-align:center; font-size:0.8em; margin-bottom:6px;">Generado: ${fecha}</div>
    <hr />
    <div>
      <div class="ec-info-row"><span class="ec-lbl">CLIENTE:</span><span>${client.client_name}</span></div>
      <div class="ec-info-row"><span class="ec-lbl">DOC:</span><span>${client.document_type || ''} ${client.document_number || ''}</span></div>
      ${client.address ? `<div class="ec-info-row"><span class="ec-lbl">DIR:</span><span>${client.address}</span></div>` : ''}
      ${client.phone ? `<div class="ec-info-row"><span class="ec-lbl">TEL:</span><span>${client.phone}</span></div>` : ''}
    </div>

    <div class="ec-detalle-title">Detalle de Deudas</div>
    <table>
      <tr><th>Fecha</th><th>Documento</th><th class="r">Venta</th><th class="r">Deuda</th></tr>
      ${rowsHtml || '<tr><td colspan="4" style="text-align:center">Sin deudas registradas</td></tr>'}
    </table>

    <hr />
    <div class="ec-total-line"><span>TOTAL DEUDA</span><span>S/ ${fmt2(totals?.total_restante)}</span></div>

    <script>window.onload = () => { window.print(); };</script>
  </body></html>`;
}

const WINDOW_SIZE = { a4: 'width=800,height=700', '80': 'width=420,height=650' };

/**
 * @param {object} data { empresa, client, debts, totals }
 * @param {'a4'|'80'} fmt
 */
export function imprimirEstadoCuenta(data, fmt = 'a4') {
  const html = fmt === '80' ? buildHtml80mm(data) : buildHtmlA4(data);
  const win = window.open('', '_blank', WINDOW_SIZE[fmt] || WINDOW_SIZE.a4);
  if (!win) return;
  win.document.write(html);
  win.document.close();
}
